import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

export const buildCustomerSiteForm = (formBuilder: UntypedFormBuilder): UntypedFormGroup => {
  return formBuilder.group({
    siteCode: ['', Validators.required],
    siteName: ['', Validators.required],
  });
};
